import { IApplicationState } from '../../types/redux';

export const selectHouseInfo = (state: IApplicationState) => state.houseInfo;
